let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_TEMPLATE": "Create Template",
    "LBL_VIEW_TEMPLATE": "View Template",
    "LBL_TEMPLATE_NAME": "Template Name",
    "LBL_CREATE_TEMPLATE": "Create Template",
    "LBL_TEMPLATE_TEXT": "Template Text",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
    "LBL_BUDGETHEAD_SEQUENCE":"Head Sequence",
}

export default language;